import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/admins`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'CreateSupportRegistration' },
  { name: 'deleteSupportRegistration' },
  { name: 'GetAllCasgUsers' },
  { name: 'GetProducersByAgencyID' },
  { name: 'GetProducerDownstream' },
  { name: 'GetSupportRegistrationByBaseProducer' },
]);

const GetProducerDownstream = (body) => api.endpoints.GetProducerDownstream.post(body);
const GetAllCasgUsers = () => () => api.createBasicCRUDEndpoints('users/casg').get();
const GetProducerDownstreamAsync = (ProducerID) =>
  api.endpoints.GetProducerDownstream.postMultipleQueryStringAsync([
    {
      queryParam: 'ProducerID',
      queryVal: ProducerID,
    },
  ]);
const GetProducersByAgencyID = (body) => api.endpoints.GetProducersByAgencyID.post(body);
const GetSupportRegistrationByBaseProducer = (body) =>
  api.endpoints.GetSupportRegistrationByBaseProducer.post(body);
const CreateSupportRegistration = (body) => api.endpoints.CreateSupportRegistration.post(body);
const DeleteSupportRegistration = (RegistrationID) =>
  api.endpoints.deleteSupportRegistration.postMultipleQueryString([
    {
      queryParam: 'RegistrationID',
      queryVal: RegistrationID,
    },
  ]);

export {
  GetProducerDownstream,
  GetProducerDownstreamAsync,
  GetProducersByAgencyID,
  GetSupportRegistrationByBaseProducer,
  CreateSupportRegistration,
  DeleteSupportRegistration,
  GetAllCasgUsers,
};
